import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { PerformanceReportingDimensionsResponse } from '../_types';
import { generateDimensions } from './performanceReportingDataGenerator';
import { useRiskPoolPerformanceReportingDemo } from '../../../../_data_sources/useRiskPoolPerformanceReportingDemo';

interface UseDimensionsParams {
  orgId: string;
  childOrgId: string;
  assignedModule: string;
  startDate: string;
  endDate: string;
}

export default function useDimensions(
  params: UseDimensionsParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const useDemoData = useRiskPoolPerformanceReportingDemo();

  return useQuery<PerformanceReportingDimensionsResponse, Error>(
    [
      'risk_pool_perf_report_dimensions',
      params.orgId,
      params.childOrgId,
      params.assignedModule,
      params.startDate,
      params.endDate,
    ],
    async (): Promise<PerformanceReportingDimensionsResponse> => {
      try {
        if (useDemoData) {
          const demoData = generateDimensions(params.childOrgId, params.assignedModule, params.startDate, params.endDate);
          console.log('[useDimensions] Demo Data Response:', JSON.stringify(demoData, null, 2));
          return demoData;
        }

        const queryParams = createParamString({
          assignedModule: params.assignedModule,
          startDate: params.startDate,
          endDate: params.endDate,
        });
        const url = `${baseApiUrl()}/organizations/${params.orgId}/risk-pool/related-organizations/${params.childOrgId}/performance-reporting/dimensions?${queryParams}`;
        const data: PerformanceReportingDimensionsResponse = await fetcher({
          method: 'get',
          url,
        });
        console.log('[useDimensions] API Response:', JSON.stringify(data, null, 2));
        return data;
      } catch (err) {
        if (onError) onError(err as ServerErrorResponse);
        throw err;
      }
    },
    {
      ...options,
      enabled:
        !!params.orgId &&
        !!params.childOrgId &&
        !!params.assignedModule &&
        !!params.startDate &&
        !!params.endDate,
    }
  );
}

